import Vue from 'vue'
import Router from 'vue-router'

// Chunking components to allow faster loading of the page

const Home = () => import('./views/Home.vue')
const List = () => import('./views/List.vue')
const HotelDetail = () => import('./views/HotelDetail.vue')
const NotFound = () => import('./views/404.vue')
const TermsAndConditions = () => import('./views/TermsAndConditions.vue')

Vue.use(Router)

const routes = [
  { path: '/404', name: 'notfound', component: NotFound },
  { path: '/', name: 'home', component: Home },
  { path: '/list', name: 'list', component: List },
  { path: '/terms', name: 'terms', component: TermsAndConditions },
  { path: '/hotel/:id', name: 'hotel-detail-page', component: HotelDetail },
  { path: '*', redirect: '/404' }
]

export default new Router({
  mode: 'history',
  routes,
  linkExactActiveClass: 'selected',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
